// import React from "@types/react";

import React from "react";
import SignIn from "../SignIn";
import {ActionPageCreate, StatePageCreate} from "../PageCreate";

class SectionHandler {
    state : StatePageCreate;
    dispatch : React.Dispatch<ActionPageCreate>;
    signIn : SignIn;

    constructor(state : StatePageCreate, dispatch : React.Dispatch<ActionPageCreate>) {
        this.state = state;
        this.dispatch = dispatch;
        this.signIn = new SignIn(this.state, this.dispatch);
    }

    nextHandler() : SectionHandler | null {
        return null;
    }

    handle() {
        return <b>Override me.</b>;
    }

    subdomain(name: string | null = null) {
        let s = (name || this.state.name).toLowerCase();
        s = s.replaceAll('ñ', 'n').replaceAll('é', 'e');
        s = s.replaceAll(/[^a-z0-9\-\s]/g, '');
        s = s.replaceAll(/\s+/g, '-');
        s = s.replace(/^\-+/, '').replace(/\-+$/, '');
        s = s.replaceAll(/\-+/g, '-');
        return s;
    }

    generate = () => {
        this.state.imagerSample.get(null, (json) => {
            console.log("generated", json);
            this.dispatch({type: 'toggle-set', payload: 'generated', value: true});
            this.dispatch({type: 'toggle-set', payload: 'name-complete', value: true});
            this.dispatch({type: 'set-generated', payload: json});
        });
    }
}
export default SectionHandler;
